import React, { useState, useRef, useCallback, useMemo, useEffect, useLayoutEffect } from 'react';
import VideoMarquee from '../../components/video-marquee';
import VideoMarqueeMeet from '../../components/video-marquee-meet';
import VideoMarqueeMeetWithShare from '../../components/video-marquee-meet-with-share';
import MediaBoard from '../../components/mediaboard';// share 
import Roomboard from '../../components/roomboard'; // chat
import { t } from '../../i18n';

import 'bootstrap/dist/css/bootstrap.css';

import './meet-class-style.scss';
import './meet-class.scss';


// chat 
import ChatPanel from '../../components/chat/panel';
import StudentList from '../../components/student-list';
import useChatText from '../../hooks/use-chat-text';
import { useGlobalState, useRoomState, useWhiteboardState } from '../../containers/root-container';
import { globalStore } from '../../stores/global';

// share
import Whiteboard from '../../components/whiteboard';
import VideoPlayer from '../../components/video-player';
import Control from '../../components/whiteboard/control';
import { AgoraStream } from '../../utils/types';
import useStream from '../../hooks/use-streams';
import { useLocation } from 'react-router';
import Tools from '../../components/whiteboard/tools';
import { SketchPicker, RGBColor } from 'react-color';
import { AgoraElectronClient } from '../../utils/agora-electron-client';
import { UploadBtn } from '../../components/whiteboard/upload/upload-btn';
import { ResourcesMenu } from '../../components/whiteboard/resources-menu';
import ScaleController from '../../components/whiteboard/scale-controller';
import { PPTProgressPhase } from '../../utils/upload-manager';
import { UploadNoticeView } from '../../components/whiteboard/upload/upload-notice';
import Progress from '../../components/progress/progress';
import { roomStore } from '../../stores/room';
import { whiteboard } from '../../stores/whiteboard';
import { platform } from '../../utils/platform';
import AgoraWebClient, { SHARE_ID } from '../../utils/agora-rtc-client';
import "white-web-sdk/style/index.css";
import { ViewMode } from 'white-web-sdk';

import { resolveMessage, resolvePeerMessage, jsonParse } from '../../utils/helper';
// video 
import '../../components/video-marquee-meet.scss';
import { AgoraMediaStream } from '../../utils/types';
import styles from '../../components/video-marquee-meet.module.scss'



const Carousel = require('react-grid-carousel');
// import RoomboardMeet from '../../components/roomboard';
const lang = JSON.parse(localStorage.getItem("language") as string) === 'en-US' || JSON.parse(localStorage.getItem("language") as string) === 'en' ? 'en' : 'ar';
const ControlBtnGroup = (props: any) => {
  return (
    <div className={styles.controlBar}>
      <div className={styles.leftBtn} onClick={props.handleLeftBtnClick}>
        <span className={lang == 'ar' ? styles.rightArrow : styles.leftArrow}></span>
      </div>
      <div className={styles.rightBtn} onClick={props.handleRightBtnClick}>
        <span className={lang == 'ar' ? styles.leftArrow : styles.rightArrow}></span>
      </div>
    </div>
  )
}

const pathName = (path: string): string => {
  const reg = /\/([^/]*)\//g;
  reg.exec(path);
  if (RegExp.$1 === "aria") {
    return "";
  } else {
    return RegExp.$1;
  }
}

interface MediaBoardProps {
  handleClick?: (type: string) => void
  children?: any
}

type SessionInfo = {
  flagShareScreen: boolean
}
const defaultState: SessionInfo = {
  flagShareScreen: true,
}


const showScrollbar = () => {
  const $marquee = document.querySelector(".video-marquee .agora-video-view");
  if ($marquee) {
    const clientWidth = $marquee.clientWidth;
    const marqueeLength: number = document.querySelectorAll(".video-marquee .agora-video-view").length;
    const videoMarqueeMark = document.querySelector('.video-marquee-mask')
    if (clientWidth && videoMarqueeMark) {
      const videoMarqueeWidth = videoMarqueeMark.clientWidth;
      const width: number = clientWidth * marqueeLength;
      // console.log("[video-marquee] videoMarqueeWidth: ", videoMarqueeWidth, ", width: ", width);
      if (videoMarqueeWidth <= width) {
        return true;
      }
    }
  }
  return false;
}
// 

export default function MeetClass() {
  const [session, setSessionInfo] = useState<SessionInfo>(defaultState);
  // agora meet style
  const layoutClasses = [
    'lector-lobby',
    'lector-tile-layout'
  ]
  const [layout, setLayout] = useState<number>(0)
  const layoutClass = layoutClasses[layout]
  const [focused, setFocused] = useState<boolean>(false)


  // chat 
  const {
    role, list, value,
    messages, sendMessage, handleChange
  } = useChatText();

  const { active } = useGlobalState();
  const [newChat, setNwChat] = useState(false);
  const [visible, setVisible] = useState(false);
  const [muteVideo, setMuteVideo] = useState(true);
  const [muteAudio, setMuteAudio] = useState(false);
  const [flagShats, setflagChats] = useState(true);

  const toggleCollapse = (evt: any) => {
    setVisible(!visible);
  }

  const goBack = (evt: any) => {
    globalStore.showDialog({
      type: 'goBack',
      message: t('toast.quit_room'),
    });
    localStorage.removeItem("RoomData");
    sessionStorage.removeItem("LoginRoomData");
  }
  const muteMyVideo = () => {
    setMuteVideo(!muteVideo);
    if (!muteVideo) {
      roomStore.mute(me.uid, 'video')
        .then(() => {
        }).catch(console.warn)
        .finally(() => {
          lock.current = false;
        });
    } else {
      roomStore.unmute(me.uid, 'video')
        .then(() => {
        }).catch(console.warn)
        .finally(() => {
          lock.current = false;
        });
    }
  }

  const muteMyAudio = () => {
    setMuteAudio(!muteAudio)
    if (!muteAudio) {
      roomStore.mute(me.uid, 'audio')
        .then(() => {
        }).catch(console.warn)
        .finally(() => {
          lock.current = false;
        });
    } else {
      roomStore.unmute(me.uid, 'audio')
        .then(() => {
        }).catch(console.warn)
        .finally(() => {
          lock.current = false;
        });
    }
  }


  const toggleCollapseChat = (evt: any) => {
    setflagChats(false);
    setNwChat(false);
    if (active == 'studentList' && visible)
      setVisible(true);
    else
      setVisible(!visible);
    globalStore.setActive('chatroom')
  }
  const toggleCollapseMembers = (evt: any) => {
    setflagChats(false);
    if (active == 'chatroom' && visible)
      setVisible(true);
    else
      setVisible(!visible);
    globalStore.setActive('studentList')
  }

  const count = active !== 'chatroom' ? globalStore.state.newMessageCount : 0;




  // share
  const roomState = useRoomState();

  const whiteboardState = useWhiteboardState();

  const role1 = roomState.me.role;
  const room = whiteboardState.room;
  const me = roomState.me;
  const course = roomState.course;
  const rtmState = roomState.rtm;

  const ref = useRef<any>(false);

  const [pageTool, setPageTool] = useState<string>('');

  const { sharedStream } = useStream();

  const shared = roomState.rtc.shared;

  useEffect(() => {
    if (!shared && platform === 'web') return;

    const rtcClient = roomStore.rtcClient;
    if (!shared) {
      if (platform === 'electron') {
        const nativeClient = rtcClient as AgoraElectronClient;
        console.log("[native] electron screen sharing shared: ", shared, " nativeClient.shared: ", nativeClient.shared);
        nativeClient.shared &&
          nativeClient.stopScreenShare().then(() => {
            console.log("[native] remove local shared stream");
            setSessionInfo({
              ...session,
              flagShareScreen: true
            });
          }).catch(console.warn);
        return;
      }
    }

    if (platform === 'web') {
      const webClient = rtcClient as AgoraWebClient;
      // WARN: IF YOU ENABLED APP CERTIFICATE, PLEASE SIGN YOUR TOKEN IN YOUR SERVER SIDE AND OBTAIN IT FROM YOUR OWN TRUSTED SERVER API
      const screenShareToken = '';
      webClient.startScreenShare(screenShareToken).then(() => {
        webClient.shareClient.on('onTokenPrivilegeWillExpire', (evt: any) => {
          // WARN: IF YOU ENABLED APP CERTIFICATE, PLEASE SIGN YOUR TOKEN IN YOUR SERVER SIDE AND OBTAIN IT FROM YOUR OWN TRUSTED SERVER API
          const newToken = '';
          webClient.shareClient.renewToken(newToken);
        });
        webClient.shareClient.on('onTokenPrivilegeDidExpire', (evt: any) => {
          // WARN: IF YOU ENABLED APP CERTIFICATE, PLEASE SIGN YOUR TOKEN IN YOUR SERVER SIDE AND OBTAIN IT FROM YOUR OWN TRUSTED SERVER API
          const newToken = '';
          webClient.shareClient.renewToken(newToken);
        });
        webClient.shareClient.on('stopScreenSharing', (evt: any) => {
          console.log('stop screen share', evt);
          setSessionInfo({
            ...session,
            flagShareScreen: true
          });
          webClient.stopScreenShare().then(() => {
            globalStore.showToast({
              message: t('toast.canceled_screen_share'),
              type: 'notice'
            });
            roomStore.setScreenShare(false);
            setSessionInfo({
              ...session,
              flagShareScreen: true
            });
          }).catch(console.warn).finally(() => {
            console.log('[agora-web] stop share');
          })
        })
        const localShareStream = webClient.shareClient._localStream
        const _stream = new AgoraStream(localShareStream, localShareStream.getId(), true);
        roomStore.addLocalSharedStream(_stream);
      }).catch((err: any) => {
        roomStore.setScreenShare(false);
        if (err.type === 'error' && err.msg === 'NotAllowedError') {
          globalStore.showToast({
            message: t('toast.canceled_screen_share'),
            type: 'notice'
          });
        }
        if (err.type === 'error' && err.msg === 'PERMISSION_DENIED') {
          globalStore.showToast({
            message: t('toast.screen_sharing_failed', { reason: err.msg }),
            type: 'notice'
          });
        }
        console.warn(err);
      }).finally(() => {
        console.log('[agora-web] start share');
      })
      return () => {
        console.log("before shared change", shared);
        shared && webClient.stopScreenShare().then(() => {
          roomStore.setScreenShare(false);
          setSessionInfo({
            ...session,
            flagShareScreen: true
          });
        }).catch(console.warn).finally(() => {
          console.log('[agora-web] stop share');
        })
      }
    }
  }, [shared]);

  const handlePageTool: any = (evt: any, type: string) => {
    setPageTool(type);
    console.log("[page-tool] click ", type);
    if (type === 'screen_sharing') {
      roomStore.setScreenShare(true);
      setSessionInfo({
        ...session,
        flagShareScreen: false
      });
      if (platform === 'electron') {
        const rtcClient = roomStore.rtcClient;
        globalStore.setNativeWindowInfo({
          visible: true,
          items: (rtcClient as AgoraElectronClient).getScreenShareWindows()
        })
      }
    }

    if (type === 'quit_screen_sharing') {
      roomStore.setScreenShare(false);
    }

    if (type === 'peer_hands_up') {
      globalStore.showDialog({
        type: 'apply',
        message: `${globalStore.state.notice.text}`,
      })
      setPageTool('');
    }

  }

  const isHost = useMemo(() => {
    return +roomStore.state.me.uid === +roomStore.state.course.linkId;
  }, [roomStore.state.me.uid,
  roomStore.state.course.linkId]);

  const location = useLocation();

  const current = useMemo(() => {
    return whiteboardState.scenes.get(whiteboardState.currentScenePath);
  }, [whiteboardState.scenes, whiteboardState.currentScenePath]);


  const addNewPage: any = (evt: any) => {
    if (!current || !room) return;
    // const newIndex = netlessClient.state.sceneState.scenes.length;
    const newIndex = room.state.sceneState.index + 1;
    const scenePath = room.state.sceneState.scenePath;
    const currentPath = `/${pathName(scenePath)}`;
    room.putScenes(currentPath, [{}], newIndex);
    room.setSceneIndex(newIndex);
    whiteboard.updateRoomState();
  }

  const showControl: boolean = useMemo(() => {
    if (me.role === 'teacher' || (me.role === 'student' && me.share)) return true;
    if (location.pathname.match(/big-class/)) {
      if (me.role === 'student') {
        return true;
      }
    }
    return false;
  }, []);

  const items = [
    {
      name: ''
    },
  ];

  const toolItems = useMemo(() => {
    return items.filter((item: any) => {
      if (role1 === 'teacher') return item;
      if (['add', 'folder', 'upload'].indexOf(item.name) === -1) {
        if (item.name === 'hand_tool') {
          if (course.lockBoard) {
            return false;
          } else {
            return true;
          }
        }
        return item;
      }
    });
  }, [course.lockBoard]);

  const drawable: string = useMemo(() => {
    if (location.pathname.match('small-class|big-class|meet-class')) {
      if (me.role === 'teacher') {
        return 'drawable';
      }
      if (me.role === 'student') {
        console.log("agora pathname: >>>>>>> ", location.pathname, me.grantBoard, me.role, Boolean(me.grantBoard));
        if (Boolean(me.grantBoard)) {
          return 'drawable';
        } else {
          return 'panel';
        }
      }
    }
    return 'drawable';
  }, [me.role, me.grantBoard, location]);

  const [tool, setTool] = useState<string | any>(drawable === 'drawable' ? 'pencil' : '');

  const [selector, updateSelector] = useState<string>('');

  const handleToolClick = (evt: any, name: string) => {
    if (!room) return;
    if (['upload', 'color_picker', 'hand_tool'].indexOf(name) !== -1 && name === tool) {
      setTool('');
      if (name === 'hand_tool') {
        room.handToolActive = false;
        updateSelector('');
      }
      return;
    }
    if (name !== 'hand_tool') {
      room.handToolActive = false;
      updateSelector('');
    }
    setTool(name);
    if (name === 'upload'
      || name === 'folder'
      || name === 'color_picker'
      || name === 'add'
      || name === 'hand_tool'
    ) {
      if (name === 'hand_tool') {

        room.handToolActive = true;
        updateSelector('hand');
        room.setMemberState({ currentApplianceName: 'selector' });
      } else {
        if (name === 'add' && addNewPage) {
          addNewPage();
        }
      }
      return;
    }
    room.setMemberState({ currentApplianceName: name });
  }

  const onColorChanged = (color: any) => {
    if (!room) return;
    const { rgb } = color;
    const { r, g, b } = rgb;
    room.setMemberState({
      strokeColor: [r, g, b]
    });
  }

  const lock = useRef<boolean>(false);

  useEffect(() => {
    return () => {
      lock.current = true;
      whiteboard.destroy()
        .then(() => {
          console.log("destroy whiteboard");
        }).catch(console.warn);
    }
  }, []);

  useEffect(() => {
    if (!rtmState.joined) return;
    if (!lock.current && !whiteboard.state.room) {
      lock.current = true;
      whiteboard.join({
        rid: roomStore.state.course.rid,
        uid: me.boardId,
        location: location.pathname,
        userPayload: {
          userId: roomStore.state.me.uid,
          identity: roomStore.state.me.role === 'teacher' ? 'host' : 'guest'
        }
      })
        .then(() => {
          console.log("join whiteboard success");
        }).catch(console.warn)
        .finally(() => {
          lock.current = false;
        })
    }

    if (!lock.current && course.boardId && me.boardId !== course.boardId && whiteboard.state.room) {
      lock.current = true;
      whiteboard.join({
        rid: roomStore.state.course.rid,
        uid: course.boardId,
        location: location.pathname,
        userPayload: {
          userId: roomStore.state.me.uid,
          identity: roomStore.state.me.role === 'teacher' ? 'host' : 'guest'
        }
      })
        .then(() => {
          console.log("rejoin whiteboard success");
        }).catch(console.warn)
        .finally(() => {
          lock.current = false;
        })
    }

  }, [rtmState.joined, me.boardId, course.boardId]);

  const [uploadPhase, updateUploadPhase] = useState<string>('');
  const [convertPhase, updateConvertPhase] = useState<string>('');

  useEffect(() => {
    console.log("[mediaboard] uploadPhase: ", uploadPhase, " convertPhase: ", convertPhase);
  }, [uploadPhase, convertPhase]);

  const UploadPanel = useCallback(() => {
    if (tool !== 'upload' || !room) return null;
    return (<UploadBtn
      room={room}
      uuid={room.uuid}
      roomToken={room.roomToken}
      onProgress={(phase: PPTProgressPhase, percent: number) => {
        console.log("[onProgress] phase: ", phase, " percent: ", percent);
        if (phase === PPTProgressPhase.Uploading) {
          if (percent < 1) {
            !uploadPhase && updateUploadPhase('uploading');
          } else {
            updateUploadPhase('upload_success');
          }
          return;
        }

        if (phase === PPTProgressPhase.Converting) {
          if (percent < 1) {
            !convertPhase && updateConvertPhase('converting');
          } else {
            updateConvertPhase('convert_success');
          }
          return;
        }
      }}
      onSuccess={() => {
        console.log("on success");
      }}
      onFailure={(err: any) => {
        // WARN: capture exception
        if (uploadPhase === 'uploading') {
          updateUploadPhase('upload_failure');
          return;
        }
        if (convertPhase === 'converting') {
          updateConvertPhase('convert_failure');
          return;
        }
      }}
    />)
  }, [tool, room]);

  useEffect(() => {
    if (uploadPhase === 'upload_success') {
      globalStore.showUploadNotice({
        title: t('room.upload_success'),
        type: 'ok',
      });
    }
    if (uploadPhase === 'convert_failure') {
      globalStore.showUploadNotice({
        title: t('room.upload_failure'),
        type: 'error',
      });
    }
  }, [uploadPhase]);

  useEffect(() => {
    if (convertPhase === 'convert_success') {
      globalStore.showUploadNotice({
        title: t('room.convert_success'),
        type: 'ok',
      });
    }
    if (convertPhase === 'convert_failure') {
      globalStore.showUploadNotice({
        title: t('room.convert_failure'),
        type: 'error',
      });
    }
  }, [convertPhase]);

  useEffect(() => {
    if (!me.role || !room) return;
    if (me.role === 'teacher') {
      if (roomStore.state.course.lockBoard) {
        room.setViewMode(ViewMode.Broadcaster);
      } else {
        room.setViewMode(ViewMode.Freedom);
      }
    }
    if (me.role === 'student') {
      if (roomStore.state.course.lockBoard) {
        room.handToolActive = false;
        room.disableCameraTransform = true;
        room.disableDeviceInputs = true;
      } else {
        room.disableCameraTransform = false;
        room.disableDeviceInputs = false;
      }
    }
  }, [room, roomStore.state.course.lockBoard, roomStore.state.me.role]);

  const globalState = useGlobalState();

  const scale = whiteboardState.scale ? whiteboardState.scale : 1;

  const UploadProgressView = useCallback(() => {
    if (uploadPhase === 'uploading') {
      return (
        <Progress title={t("room.uploading")} />
      )
    } else
      if (convertPhase === 'converting') {
        return (
          <Progress title={t("room.converting")} />
        )
      }
    return null;
  }, [uploadPhase, convertPhase]);

  let strokeColor: RGBColor | undefined = undefined;

  if (whiteboardState.room && whiteboardState.room.state.memberState.strokeColor) {
    const color = whiteboardState.room.state.memberState.strokeColor;
    strokeColor = {
      r: color[0],
      g: color[1],
      b: color[2],
    }
  }

  useEffect(() => {
    if (!room) return;
    if (drawable === 'panel') {
      room.disableDeviceInputs = true;
      room.disableCameraTransform = true;
      return;
    }
    room.disableDeviceInputs = false;
    room.disableCameraTransform = false;
  }, [drawable, room]);

  const showTools = drawable === 'drawable';

  // video
  const { teacher, students, onPlayerClick } = useStream();

  const marqueeEl = useRef(null);

  const itemsRef = useRef<any>(null)

  const offsetXWidth = useRef<number>(0)


  // TODO: need remove
  //@ts-ignore
  window.bar = itemsRef

  useEffect(() => {
    return () => {
      itemsRef.current = null;
    }
  }, [])
  //////
  const offXLeft = (current: any, offsetX: number) => {
    current.scrollLeft -= offsetX
  }

  const offXRight = (current: any, offsetX: number) => {
    current.scrollLeft += offsetX
  }
  const handleLeftBtnClick = () => {
    if (itemsRef.current && offsetXWidth.current) {
      offXLeft(itemsRef.current, offsetXWidth.current)
    }
  }

  const handleRightBtnClick = () => {
    if (itemsRef.current && offsetXWidth.current) {
      offXRight(itemsRef.current, offsetXWidth.current)
    }
  }


  useEffect(() => {
    if (itemsRef.current) {
      offsetXWidth.current = itemsRef.current.clientWidth
    }

    window.addEventListener('resize', (evt: any) => {
      if (itemsRef.current) {
        offsetXWidth.current = itemsRef.current.clientWidth - 84
      }
    })

    return () => {
      window.removeEventListener('resize', (evt: any) => {
      })
    }


  }, [])
  //////

  const rtmClient = roomStore.rtmClient;
  rtmClient.on("ChannelMessage", ({ memberId, message }: { message: { text: string }, memberId: string }) => {
    const msg = jsonParse(message.text);
    if (msg) {
      setNwChat(true);
    } else
      setNwChat(false);


  });

  ////////
  return (
    <div className='meeting-container' style={{ direction: 'ltr' }}>
      <div className={`meeting-page ${layoutClass} ${focused ? 'focused' : ''}`} >
        <article className={`meeting-content ${layoutClass}`}>
          <div className={`content--carousel`}>
            {active == "" ?
              <>
                {!sharedStream ?
                  <VideoMarqueeMeet />
                  : <div className={`${styles.lectorLobbyLayout} ${visible && sharedStream ? 'width-fit' : ''}`}>
                    <div className={`row`} style={{ width: '100%' }}>
                      <div className={`col-10`}>
                        <div className={`zoomIn--video`}>
                          <div className={styles.mainLectorView} style={{ minHeight: '100%' }}>
                            <div className="screen">
                              <div className="container">
                                <div className={`media-board ${drawable}`}>
                                  {sharedStream ?
                                    <VideoPlayer
                                      id={`${sharedStream.streamID}`}
                                      domId={`shared-${sharedStream.streamID}`}
                                      className={'screen-sharing eeee'}
                                      streamID={sharedStream.streamID}
                                      stream={sharedStream.stream}
                                      video={true}
                                      audio={true}
                                      share={true}
                                      local={sharedStream.local}
                                    />
                                    :
                                    <Whiteboard
                                      loading={whiteboardState.loading}
                                      className={selector}
                                      room={room}
                                    />
                                  }
                                  <div className="layer">
                                    {!sharedStream ?
                                      <>
                                        {showTools ? <Tools
                                          items={toolItems}
                                          currentTool={tool}
                                          handleToolClick={handleToolClick} /> : null}
                                      </> : null}
                                    <UploadPanel />

                                  </div>
                                  {me.role === 'teacher' && room ?
                                    <ScaleController
                                      zoomScale={scale}
                                      onClick={() => {
                                        setTool('folder');
                                      }}
                                      onClickBoardLock={() => {
                                        whiteboard.lock()
                                          .then(console.log)
                                          .catch(console.warn);
                                      }}
                                      zoomChange={(scale: number) => {
                                        room.moveCamera({ scale });
                                        whiteboard.updateScale(scale);
                                      }}
                                    />
                                    :
                                    null
                                  }
                                  {(showControl || me.share) ?
                                    <Control
                                      notice={globalState.notice}
                                      role={role}
                                      sharing={Boolean(sharedStream)}
                                      current={pageTool}
                                      isHost={isHost}
                                      onClick={handlePageTool} /> : null}
                                  {tool === 'folder' && whiteboardState.room ?
                                    <ResourcesMenu
                                      active={whiteboardState.activeDir}
                                      items={whiteboardState.dirs}
                                      onClick={(rootPath: string) => {
                                        if (room) {
                                          room.setScenePath(rootPath);
                                          room.setSceneIndex(0);
                                          whiteboard.updateRoomState();
                                        }
                                      }}
                                      onClose={(evt: any) => {
                                        setTool('')
                                      }}
                                    />
                                    : null}
                                  <UploadNoticeView />
                                  <UploadProgressView />
                                  <div className="footer">
                                    <div className="circles">
                                      <div className="circle" />
                                      <div className="circle" />
                                      <div className="circle" />
                                      <div className="circle" />
                                      <div className="circle" />
                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={`col-2`}>
                        <Carousel cols={1} rows={3} scrollSnap={true} gap={10} hideArrow={true} showDots={true} dotColorActive={`#606060`} dotColorInactive={`#1c1c1c`}>
                          {teacher ?
                            <Carousel.Item>
                              <div className={`content--div--col1`}>
                                <VideoPlayer
                                  role="teacher"
                                  domId={`dom-${teacher.streamID}`}
                                  id={`${teacher.streamID}`}
                                  streamID={teacher.streamID}
                                  stream={teacher.stream}
                                  account={teacher.account}
                                  audio={Boolean(teacher.audio)}
                                  video={Boolean(teacher.video)}
                                  local={Boolean(teacher.local)}
                                  handleClick={onPlayerClick}
                                />
                              </div>
                            </Carousel.Item>
                            : null}
                          {students.map((student: AgoraMediaStream, key: number) => (

                            <Carousel.Item>
                              <div className={`content--div--col1`}>
                                <VideoPlayer
                                  role="student"
                                  domId={`dom-${student.streamID}`}
                                  key={`${key}${student.streamID}`}
                                  id={`${student.streamID}`}
                                  account={student.account}
                                  streamID={student.streamID}
                                  stream={student.stream}
                                  video={student.video}
                                  audio={student.audio}
                                  local={student.local}
                                  handleClick={onPlayerClick}
                                />
                              </div>
                            </Carousel.Item>

                          ))}
                        </Carousel>
                      </div>
                    </div>

                  </div>}
              </>
              : <div className={`row`} style={{ height: '90%', paddingTop: '16px' }}>
                {/*  chat and members */}
                <div className={`col-8`}>
                  {active && sharedStream
                    ? <div className={`zoomIn--video`} >
                      <div className={styles.mainLectorView} style={{ minHeight: '100%' }}>
                        <div className="screen">
                          <div className="container">
                            <div className={`media-board ${drawable}`}>
                              {sharedStream ?
                                <VideoPlayer
                                  id={`${sharedStream.streamID}`}
                                  domId={`shared-${sharedStream.streamID}`}
                                  className={'screen-sharing eeee'}
                                  streamID={sharedStream.streamID}
                                  stream={sharedStream.stream}
                                  video={true}
                                  audio={true}
                                  share={true}
                                  local={sharedStream.local}
                                />
                                :
                                <Whiteboard
                                  loading={whiteboardState.loading}
                                  className={selector}
                                  room={room}
                                />
                              }
                              <div className="layer">
                                {!sharedStream ?
                                  <>
                                    {showTools ? <Tools
                                      items={toolItems}
                                      currentTool={tool}
                                      handleToolClick={handleToolClick} /> : null}
                                  </> : null}
                                <UploadPanel />

                              </div>
                              {me.role === 'teacher' && room ?
                                <ScaleController
                                  zoomScale={scale}
                                  onClick={() => {
                                    setTool('folder');
                                  }}
                                  onClickBoardLock={() => {
                                    whiteboard.lock()
                                      .then(console.log)
                                      .catch(console.warn);
                                  }}
                                  zoomChange={(scale: number) => {
                                    room.moveCamera({ scale });
                                    whiteboard.updateScale(scale);
                                  }}
                                />
                                :
                                null
                              }
                              {(showControl || me.share) ?
                                <Control
                                  notice={globalState.notice}
                                  role={role}
                                  sharing={Boolean(sharedStream)}
                                  current={pageTool}
                                  isHost={isHost}
                                  onClick={handlePageTool} /> : null}
                              {tool === 'folder' && whiteboardState.room ?
                                <ResourcesMenu
                                  active={whiteboardState.activeDir}
                                  items={whiteboardState.dirs}
                                  onClick={(rootPath: string) => {
                                    if (room) {
                                      room.setScenePath(rootPath);
                                      room.setSceneIndex(0);
                                      whiteboard.updateRoomState();
                                    }
                                  }}
                                  onClose={(evt: any) => {
                                    setTool('')
                                  }}
                                />
                                : null}
                              <UploadNoticeView />
                              <UploadProgressView />
                              <div className="footer">
                                <div className="circles">
                                  <div className="circle" />
                                  <div className="circle" />
                                  <div className="circle" />
                                  <div className="circle" />
                                  <div className="circle" />
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>

                    : <div className={`zoomIn--video`}>
                      <Carousel cols={2} rows={3} scrollSnap={true} gap={10} hideArrow={true} showDots={true} dotColorActive={`#606060`} dotColorInactive={`#1c1c1c`}>
                        {teacher ?
                          <Carousel.Item>
                            <div className={`content--div--col1`}>
                              <VideoPlayer
                                role="teacher"
                                domId={`dom-${teacher.streamID}`}
                                id={`${teacher.streamID}`}
                                streamID={teacher.streamID}
                                stream={teacher.stream}
                                account={teacher.account}
                                audio={Boolean(teacher.audio)}
                                video={Boolean(teacher.video)}
                                local={Boolean(teacher.local)}
                                handleClick={onPlayerClick}
                              />
                            </div>
                          </Carousel.Item>
                          : null}
                        {students.map((student: AgoraMediaStream, key: number) => (

                          <Carousel.Item>
                            <div className={`content--div--col1`}>
                              <VideoPlayer
                                role="student"
                                domId={`dom-${student.streamID}`}
                                key={`${key}${student.streamID}`}
                                id={`${student.streamID}`}
                                account={student.account}
                                streamID={student.streamID}
                                stream={student.stream}
                                video={student.video}
                                audio={student.audio}
                                local={student.local}
                                handleClick={onPlayerClick}
                              />
                            </div>
                          </Carousel.Item>

                        ))}
                      </Carousel>
                    </div>}


                </div>
                <div className={`col-4`}>
                  <div className={`small-class chat-board  ${sharedStream ? 'meet-chat' : ''}`} style={{ backgroundColor: '#fff', height: '100%', borderRadius: '10px', width: '100%', maxWidth: '100%' }}>
                    <div className="menu">
                      <div onClick={() => { globalStore.setActive('studentList') }} className={`item ${active === 'studentList' ? 'active' : ''}`}>
                        <img className={`img--icon`} src={require('../../assets/images/users-icon.svg')} alt="share--icon" width="22" height="14" />
                        {t('room.student_list')}
                      </div>
                      <div onClick={() => { globalStore.setActive('chatroom') }} className={`item ${active === 'chatroom' ? 'active' : ''}`}>
                        <img className={`img--icon`} src={require('../../assets/images/chat-icon.svg')} alt="share--icon" width="22" height="14" />
                        {t('room.chat_room')}

                        {active !== 'chatroom' && count > 0 ? <span className={`message-count ${globalStore.state.language}`}>{count}</span> : null}
                      </div>
                      <div className={`cancel--icon`} onClick={() => { globalStore.setActive('') }}>
                        <img className={`img--icon`} src={require('../../assets/images/cancel-icon.svg')} alt="cancel--icon" width="14" height="14" />
                      </div>
                    </div>
                    <div className={`chat-container ${active === 'chatroom' ? '' : 'hide'}`}>
                      <ChatPanel
                        messages={messages}
                        value={value}
                        sendMessage={sendMessage}
                        handleChange={handleChange} />
                    </div>
                    <div className={`student-container ${active !== 'chatroom' ? '' : 'hide'}`}>
                      <StudentList
                        role={role}
                        list={list}
                      />
                    </div>
                  </div>
                </div>
              </div>
            }

          </div>


        </article>
        <div className={`footer--meet-class`}>
          <div className={`row`}>
            <div className={`col-7 icons--container ${sharedStream ? 'padding--top' : ''}`}>
              <div className={`row`}>
                <div className={`red--circle`} onClick={evt => { goBack('goBack') }}>
                  <img src={require('../../assets/images/phone-icon.png')} alt="phone-icon" width='24' height='8.9' />
                </div>
                <div className={`${!me.video ? 'white--circle' : 'gray--circle'}`} onClick={() => muteMyVideo()}>
                  <img src={!me.video ? require('../../assets/images/mute-video-icon.svg') : require('../../assets/images/video-icon.png')} alt="video-icon" width='18' height='12' />
                </div>
                <div className={`${!me.audio ? 'white--circle' : 'gray--circle'}`} onClick={() => muteMyAudio()}>
                  <img src={!me.audio ? require('../../assets/images/mute-audio-icon.svg') : require('../../assets/images/audio-icon.png')} alt="audio-icon" width='14' height='19' />
                </div>
              </div>
            </div>
            {!sharedStream
              ? <div className={`col-5 share--container`}>
                <div className={`screen--share-content`} onClick={evt => { handlePageTool('', 'screen_sharing') }}>
                  <h1 className={`share--screen--text`}>{t('share_your_screen')}</h1>
                  <img src={require('../../assets/images/share-arrow-bottom-icon.png')} alt="share-your-screen" width='24' height='16' />
                </div>
              </div>
              : null}
          </div>
        </div>
      </div>
    </div>
  )
}
